import React from 'react'
import { CHeader, CHeaderToggler } from '@coreui/react'
import { Link, useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import WalletButton from '../chain/WalletButton'

const TITLES = {
  '/dashboard': 'Overview',
  '/dashboard/menu-products': 'Products',
  '/dashboard/products': 'Products',
  '/dashboard/orders': 'Orders',
  '/dashboard/messages': 'Messages',
  '/dashboard/deals': 'Deals',
  '/dashboard/category': 'Categories',
  '/dashboard/upgrade': 'Subscription',
  '/dashboard/pre-order': 'Analytics',
  '/dashboard/reviews': 'Reviews',
  '/dashboard/edit': 'Edit Profile',
  '/dashboard/gallery': 'Photos',
  '/dashboard/publicProfile': 'Public Page',
  '/dashboard/invoice': 'Invoices',
}

export default function Dash_header() {
  const dispatch = useDispatch()
  const sidebarShow = useSelector(state => state.sidebarShow)
  const user = useSelector(state => state.user)
  const location = useLocation()
  const title = TITLES[location.pathname] || 'Dashboard'

  return (
    <CHeader position="sticky" className="bp-dash-header">
      <CHeaderToggler
        className="ms-3"
        onClick={() => dispatch({ type: 'set', sidebarShow: !sidebarShow })}
      />
      <div className="bp-dash-title">
        <span className="bp-sec-label" style={{ marginBottom: 2 }}>SELLER DASHBOARD</span>
        <h4>{title}</h4>
      </div>
      <div className="bp-dash-actions">
        {user && user.businessName && (
          <span className="bp-dash-biz bp-mono">{user.businessName}</span>
        )}
        <WalletButton />
        <Link to="/" className="bp-btn-ghost bp-dash-store">View Store</Link>
        <a href="/logout" className="bp-dash-logout" title="Logout"><i className="fa fa-sign-out" /></a>
      </div>
    </CHeader>
  )
}
